import React, { PropsWithChildren, FC } from "react";

import { Container } from "../container";

type PageProps = PropsWithChildren<{
  readonly className?: string;
}>;

export const Page: FC<PageProps> = ({ className = "", children }) => (
  <Container className={className}>{children}</Container>
);
